<template>
  <div>
    <a-card v-for="(item, index) in services" :key="index" class="service-form-card">
      <a-row>
        <a-col :span="10">
          <a-avatar size="small" :src="serviceTypes[item.service_type].image" />
          <span class="service-card_name">{{ servicesData[item.service_id].service_name }} </span>
        </a-col>
        <a-col :span="7">
          <span class="service-card_lable">版本:</span>
          <span class="service-card_value">{{ item.artifact_version !== null ? item.artifact_version : item.image }}</span>
        </a-col>
        <a-col :span="6">
          <span class="service-card_lable">开发者:</span>
          <span class="service-card_value">{{ item.developers.map(d => users[d].nickname).join(';') }} </span>
        </a-col>
        <a-col :span="1">
          <a-dropdown placement="bottomCenter" class="service-card_action">
            <a> <a-icon type="more" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="onModify(item, index)">修改</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="onDelete(index)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </a-col>
      </a-row>
      <div v-if="Array.isArray(item.data_change) && item.data_change.length > 0">
        <span class="service-card_lable">配置变更:</span>
        <span class="service-card_value">
          <a-tag v-for="key in item.data_change" :key="key" color="pink">{{ dataChangeOptionMap[key].label }}</a-tag>
        </span>
      </div>
      <div v-if="Array.isArray(item.configs) && item.configs.length > 0">
        <span class="service-card_lable">确认配置项:</span>
        <span class="service-card_value">
          <a-tag v-for="(config, i) in item.configs" :key="i" color="orange">{{ config }}</a-tag>
        </span>
      </div>
    </a-card>
    <a-card class="add-btn" size="small" @click="onAddService"><a-icon type="plus" /> 添加服务 </a-card>
    <service-modal :selected-services="selectedServices" :template-id="templateId" :is-show="addVisible" :modify-index="modifyIndex" :users="users" :modify-service="modifyService" :services-data="servicesData" @close="close" @submitAddService="submitAddService" />
  </div>
</template>

<script>
import { userList } from '@/api/system/auth';
import { serviceList } from '@/api/system/service';
import { serviceTypes, dataChangeOptions } from '@/utils/dictionary';

import ServiceModal from '@/pages/project/workflow/release/components/ServiceModal';

export default {
  components: { ServiceModal },
  model: {
    event: 'change',
    prop: 'sourceData'
  },
  props: {
    projectId: {
      type: Number,
      default: 1
    },
    releaseId: {
      type: Number,
      default: null
    },
    workflowId: {
      type: Number,
      default: null
    },
    templateId: {
      type: Number,
      default: null
    },
    sourceData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      serviceTypes,
      dataChangeOptions,
      users: {},
      services: [],
      selectedServices: [],
      filterForm: {
        service_id: null
      },
      servicesData: {},
      serviceInfo: {},
      modifyService: {},
      modifyIndex: null,
      addVisible: false
    };
  },
  computed: {
    dataChangeOptionMap() {
      return this.dataChangeOptions.reduce((results, item, _) => {
        results[item.value] = item;
        return results;
      }, {});
    }
  },
  watch: {
    sourceData() {
      this.services = this.sourceData;
      this.selectedServices = this.sourceData.map(item => {
        return item.service_id;
      });
    }
  },
  created() {
    this.getUserList();
    this.getServiceList();
  },
  methods: {
    /**
     * 添加服务
     */
    onAdd() {
      this.$emit('change', this.services);
    },

    /**
     * 获取服务列表
     */
    getServiceList() {
      serviceList({ project_id: this.projectId }).then(res => {
        const services = {};
        const serviceList = res.data.services;
        serviceList.forEach(row => {
          services[row.service_id] = row;
        });
        this.servicesData = services;
      });
    },

    /**
     * 点击添加服务
     */
    onAddService() {
      this.modifyService = {};
      this.modifyIndex = null;
      this.addVisible = true;
    },

    /**
     * 获取用户列表
     */
    getUserList() {
      userList({ return_type: 'dict' }).then(res => {
        this.users = res.data.users;
      });
    },

    /**
     * 点击删除服务
     * @param {*} index
     */
    onDelete(index) {
      this.services.splice(index, 1);
      this.selectedServices.splice(index, 1);
    },

    /**
     * 点击修改服务
     * @param {*} record
     * @param {*} index
     */
    onModify(record, index) {
      this.addVisible = true;
      this.modifyService = { ...record };
      this.modifyIndex = index;
    },

    /**
     * 关闭模态框
     */
    close() {
      this.addVisible = false;
    },

    /**
     * 提交添加服务
     * @param {*} service
     * @param {*} index
     */
    submitAddService(service, index = null) {
      this.addVisible = false;
      if (index !== null) {
        this.services[index] = service;
        this.selectedServices[index] = service.service_id;
        this.$emit('change', this.services);
        this.$message.success('服务修改成功');
      } else {
        this.services.push(service);
        this.selectedServices.push(service.service_id);
        this.$emit('change', this.services);
        this.$message.success('服务添加成功');
      }
      this.modifyService = {};
      this.modifyIndex = null;
    }
  }
};
</script>

<style lang="less" scoped>
.add-btn {
  cursor: pointer;
  text-align: center;
  border: 1px dashed #d9d9d9;
}
/deep/ .ant-card-body {
  padding: 16px;
}
.ant-card {
  margin-bottom: 8px;
}

.service-card_lable {
  color: rgba(0, 0, 0, 0.35);
  margin-right: 4px;
}
.service-card_name {
  display: inline-block;
  height: 24px;
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
  vertical-align: top;
}
.service-card_action {
  display: inline-block;
  width: 100%;
  text-align: right;
  align-items: right;
}
.service-card_value {
  display: inline;
  line-height: 28px;
}
</style>
